import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import Loader from "../../../loader/Loader";
import {
  getAdvert,
  selectIsLoading,
  selectAdd,
  updateAdvert,
} from "../../../../redux/features/add/addSlice";
import AddForm from "../addForm/AddForm";

const EditAdd = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isLoading = useSelector(selectIsLoading);

  const addEdit = useSelector(selectAdd);
  const [files, setFiles] = useState([]);
  const [add, setAdd] = useState(addEdit);
  const [addImage, setAddImage] = useState("");
  const [imagePreview, setImagePreview] = useState([]);
  const [content, setContent] = useState("");

  useEffect(() => {
    dispatch(getAdvert(id));
  }, [dispatch, id]);

  useEffect(() => {
    setAdd(addEdit);

    if (addEdit && addEdit.image) {
      setFiles(addEdit.image);
    }

    setContent(addEdit && addEdit.content ? addEdit.content : "");
  }, [addEdit]);

  const saveAdd = async (e) => {
    e.preventDefault();
    if (files.length < 1) {
      return toast.info("Please add an image");
    }

    const formData = {
      link: add?.link,
      category: add?.category,
      content: content,
      image: files,
    };

    // console.log(formData);

    await dispatch(getAdvert());
    await dispatch(updateAdvert({ id, formData }));
    navigate("/admin/all-adds");
  };

  return (
    <div>
      {isLoading && <Loader />}
      <h2 className="--mt">Edit Add</h2>
      <AddForm
        files={files}
        isEditing={true}
        setFiles={setFiles}
        add={add}
        setAdd={setAdd}
        addImage={addImage}
        imagePreview={imagePreview}
        setImagePreview={setImagePreview}
        content={content}
        setContent={setContent}
        saveAdd={saveAdd}
      />
    </div>
  );
};

export default EditAdd;
